import { TYPES } from './ui.types'

const initialState = {
  trial_passed: null,
  isSocketConnected: false,
  isBottomBarVisible: true,
  popupAboutSocialMediaStatus: null,
  hasSurvey: null,
  surveyData: [],
}

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case TYPES.UPDATE_INFO:
      return {
        ...state,
        ...action.payload,
      }

    case TYPES.SET_INFO: {
      return {
        ...state,
        ...action.payload,
      }
    }

    case TYPES.SET_IS_SOCKET_CONNECTED: {
      const { status } = action.payload

      return {
        ...state,
        isSocketConnected: status,
      }
    }

    case TYPES.SET_BOTTOM_BAR_VISIBLE: {
      const { isBottomBarVisible } = action.payload

      return {
        ...state,
        isBottomBarVisible,
      }
    }

    case TYPES.SET_SURVEY_STATUS: {
      const { hasSurvey } = action.payload

      return {
        ...state,
        hasSurvey,
      }
    }

    case TYPES.SET_SURVEY_DATA: {
      return {
        ...state,
        surveyData: action.payload,
      }
    }

    case TYPES.CLEAR_SURVEY: {
      return {
        ...state,
        surveyData: initialState.surveyData,
        hasSurvey: false,
      }
    }

    case TYPES.SET_SOCIAL_MEDIA_BANNER_STATUS:
      return {
        ...state,
        popupAboutSocialMediaStatus: action.payload,
      }

    default:
      return state
  }
}
